<template>
  <div
    class="more-service"
    v-if="expandServices.length"
  >
    <p class="more-service__title">
      More Services
    </p>
    <div class="more-service__content">
      <div
        v-for="service of expandServices"
        class="more-service-item"
        :class="{
          'more-service-item--active': service.quantity === 1
        }"
        @click="service.quantity = service.quantity === 1 ? 0 : 1"
      >
        <Image
          class="more-service-item__image"
          :src="service.skuImageUrl"
        />
        <div class="more-service-item__content">
          <p class="more-service-item__title">
            {{ service.tag }}
          </p>
          <p
            class="more-service-item__hint"
            v-if="service.canUseMoq > 1"
          >
            (MOQ>={{ service.canUseMoq }})
          </p>
          <div class="more-service-item__footer">
            <p class="more-service-item__price">
              <IntlCurrency
                :currency="currency.current.targetCurrency"
              />
              {{ bankersRoundWithMax(service.price * currency.current.rate, 0.01) }}
            </p>
            <img
              class="more-service-item__icon"
              :src="service.quantity === 1 ? SelectedImage : UnSelectImage"
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Image } from '@/components/Image'
import UnSelectImage from '@/assets/offer/unselect.svg'
import SelectedImage from '@/assets/offer/selected.svg'
import { IntlCurrency } from '@/components/NewIntlCurrency'
import { useCurrencyStore } from '@/pinia/currency'
import { useProductDetail } from '@/views/OfferView/components/hooks/useProductDetail'
import { bankersRoundWithMax } from '@/utils/utils'

const { expandServices } = useProductDetail()

const currency = useCurrencyStore()
</script>

<style lang="less" scoped>
.more-service {
  padding-top: 20px;
  border-bottom: 1px solid #EBF1F5;

  &__title {
    font-family: mon-700;
    font-size: 14px;
    line-height: 18px;
  }

  &__content {
    padding-top: 8px;
    padding-bottom: 20px;
    display: flex;
    gap: 12px;
    overflow-x: auto;
  }

  &-item {
    display: flex;
    align-items: center;
    padding: 12px 8px;
    gap: 8px;
    border-radius: 8px;
    border: 1.5px solid #F8F8F8;
    min-width: 160px;
    background: #F8F8F8;
    cursor: pointer;

    &--active {
      border-color: #1B3E9C;
      background: #EFF4FD;
    }

    &--disabled {
      opacity: .6;
      pointer-events: none;
    }

    &__image {
      flex-shrink: 0;
      width: 48px;
      height: 48px;
      border-radius: 4px;
    }

    &__content {
      flex: 1;
      min-width: 0;
      color: #232323;
    }

    &__title {
      font-family: mon-500;
      font-size: 12px;
      line-height: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &__hint {
      font-family: mon-500;
      font-size: 10px;
      line-height: 14px;
    }

    &__footer {
      margin-top: 6px;
      display: flex;
      justify-content: space-between;
      align-items: end;
    }

    &__price {
      font-family: mon-600;
      font-size: 12px;
      line-height: 16px;
    }

    &__icon {
      width: 18px;
      height: 18px;
    }
  }
}
</style>
